<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showVatNumberModal"
                   :data="model"
                   :title="$t('VAT Number')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <input-widget :autofocus="true" :label="false" :model="model" attribute="vat_number"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import VatNumberForm from "../../../models/VatNumberForm.model";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "VatNumberModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new VatNumberForm({}),
        showConfirmation: false
      }
    },
    methods: {
      ...mapActions(['toggleVatNumberModal', 'saveTermsPartialData']),
      async onSubmit() {
        this.loading = true;
        let response = await this.saveTermsPartialData({vat_number: this.model.vat_number});
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.toggleVatNumberModal(false);
          this.$toast('success', this.$t('VAT number was successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
        this.model = new VatNumberForm({vat_number: this.vatNumber});
      },
      onHidden() {
        this.model = new VatNumberForm();
        this.toggleVatNumberModal(false);
      },
    },
    watch: {
      vatNumber() {
        this.model = new VatNumberForm({vat_number: this.vatNumber});
      }
    },
    computed: {
      ...mapState({
        showVatNumberModal: state => state.termsData.showVatNumberModal,
        vatNumber: state => state.termsData.vat_number
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>

